import React from 'react';
import Heading from '../../Components/Heading';
import Icon from '../../Components/Icon';

class FaqDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      childHeight: 'auto'
    };
    this.childRef = React.createRef();
    this.headerRef = null;
  }

  toggleDropDown = () => {
    this.setState(prevState => {
      const newStatus = !prevState.active;
      const childHeight = newStatus
        ? this.childRef.current.clientHeight + this.headerRef.clientHeight
        : this.headerRef.clientHeight;

      return {
        childHeight,
        active: newStatus
      };
    });
  };

  setHeaderRef = ref => {
    if (!ref) {
      return;
    }
    this.headerRef = ref;
    this.setState({
      childHeight: this.headerRef.offsetHeight
    });
  };

  render() {
    const { title, children } = this.props;
    const { active, childHeight } = this.state;
    return (
      <div
        style={{
          height: childHeight
        }}
        className="th-faq-drop-cont">
        <button
          ref={this.setHeaderRef}
          className="th-faq-drop-btn"
          onClick={this.toggleDropDown}>
          <span className="th-faq-drop-title">{title}</span>
          <Icon
            className="th-faq-drop-icon"
            name={`fas fa-chevron-${active ? 'up' : 'down'}`}
          />
        </button>

        <span
          style={{
            visibility: active ? 'visible' : 'hidden',
            flexBasis: active ? 'auto' : '0'
          }}
          ref={this.childRef}
          className="th-faq-drop-desc">
          {children}
        </span>
      </div>
    );
  }
}

const Faq = () => {
  return (
    <div className="th-fq-container">
      <Heading className="th-faq-heading" title="FREQUENTLY ASKED QUESTION" />

      <FaqDropDown title="Who can do this course and are there any prerequisites?">
      Practically anyone, who is looking to get a meaningful job, a job, where they grow both personally & professionally can do this course. There isn’t any prerequisite as practically everything starts from scratch. If you happen to know stuff, it’ll be a fast learning curve for you.
      </FaqDropDown>

      <FaqDropDown title="What do you mean by one to one mentorship program?">
      One to one mentorship simply reflects the fact that there will be a custom designed curriculum for you and you will be understanding things at your own pace. The mentor will be there to guide you as per your learning curve and thus removing the entire batch system.
      </FaqDropDown>

      <FaqDropDown title="How are these 300+ hours spaced?">
      This course requires you to commit at least 5-6 hours per day for 4-5 days a week. Generally, it takes around 3 months for the 300 hours to complete. You are there with us for another 3 months or less as we keep on working with you until you grab a job or an internship. For some students, they need an internship experience of 1-2 months before they get the job, and for some they grab the job directly.
      </FaqDropDown>

      <FaqDropDown title="How does the custom entrance test work and how do I prepare for it?">
      The custom entrance test is designed after understanding your desired job domain & desired package. Most part of the test focuses just on your ability to grasp concepts and doesn’t necessarily require any pre-requisite knowledge as such.
      </FaqDropDown>

      <FaqDropDown title="How does this entire placement process take place?">
      Before the Student is asked to appear for an interview in any company, Student will be presented with the hiring company’s name, it's background and job profile (As Provided by Hiring Company) by Alien Brains. If a Student agrees to be interviewed by the Hiring Company, an approved written consent with signature would be given to Alien Brains by the Student. Once the consent is there, Alien Brains will regard the offer to be valid, and will facilitate the interview process. If the Student goes forward with the interview and gets placed, and for some reason doesn't join the company, further placement assistance will only be given by Alien Brains subject to the genuineness of the student's reason (sole discretion of Alien Brains on judging genuineness) not to join the company even after getting placed.
Alien Brains will facilitate up to 10 different valid interviews across different companies if the student is not getting placed. Meanwhile, we will keep on working with the students in their weak areas.
      </FaqDropDown>
    </div>
  );
};
export default Faq;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Faq.js